import { default as urlWorkerSTLocal } from './stockfish-17-lite-single.js?url';
import { default as urlWasmSTLocal } from './stockfish-17-lite-single.wasm?url';
import { default as urlWorkerMTLocal } from './stockfish-17-lite.js?url';
import { default as urlWasmMTLocal } from './stockfish-17-lite.wasm?url';
import { default as urlWorker10LegacyLocal } from './stockfish.js?url';
import { default as urlWasm10Local } from './stockfish.wasm?url';
import { default as urlWorker10Local } from './stockfish.wasm.js?url';

let urlWorkerMT = urlWorkerMTLocal;
let urlWasmMT = urlWasmMTLocal;

let urlWorkerST = urlWorkerSTLocal;
let urlWasmST = urlWasmSTLocal;

let urlWorker10Legacy = urlWorker10LegacyLocal;
let urlWorker10 = urlWorker10Local;
let urlWasm10 = urlWasm10Local;

if (__RUNTIME.customStockfishPath) {
  urlWorkerMT = `${__RUNTIME.customStockfishPath}/stockfish-17-lite.js`;
  urlWasmMT = `${__RUNTIME.customStockfishPath}/stockfish-17-lite.wasm`;

  urlWorkerST = `${__RUNTIME.customStockfishPath}/stockfish-17-lite-single.js`;
  urlWasmST = `${__RUNTIME.customStockfishPath}/stockfish-17-lite-single.wasm`;

  urlWorker10Legacy = `${__RUNTIME.customStockfishPath}/stockfish.js`;
  urlWorker10 = `${__RUNTIME.customStockfishPath}/stockfish.wasm.js`;
  urlWasm10 = `${__RUNTIME.customStockfishPath}/stockfish.wasm`;
}

export {
  urlWorkerMT,
  urlWasmMT,
  urlWorkerST,
  urlWasmST,
  urlWorker10Legacy,
  urlWorker10,
  urlWasm10,
};
